import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'constants/QueryKeys';
import { client } from 'api/baseAxios';
import { TenderMetadata } from 'api/TenderMetadata';
import { PortalCostTypes } from '../api/api';

export type Localisation = {
  [key: string]: string;
};

export const portalCostTypeMap = {
  [PortalCostTypes.CostAmsEnsFiling]: 'AMS ENS filing',
  [PortalCostTypes.CostBookingFee]: 'Booking fee',
  [PortalCostTypes.CostCustomsTransitDocs]: 'Customs docs',
  [PortalCostTypes.CostFreightIncrease]: 'Freight increase',
  [PortalCostTypes.CostFreightIncreaseUpdate]: 'Freight increase update',
  [PortalCostTypes.CostIsps]: 'ISPS',
  [PortalCostTypes.CostVgmDeclaration]: 'VGM declaration',
  [PortalCostTypes.CostWeighing]: 'Weighing',
  [PortalCostTypes.CostLinesDocs]: 'Lines docs',
};

export const useTenderFieldsLocalisation = () => {
  const { isLoading, data } = useQuery({
    queryKey: [queryKeys.TENDER_DEFAULT_FIELDS],
    queryFn: () => client(TenderMetadata).defaultFieldsList(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
  });

  const localisation = useMemo<Localisation>(
    () => {
      if (isLoading || !data) {
        return {};
      }

      const fieldLocalisation = [
        ...(data?.fields ?? []),
        ...(data?.freeTimes ?? []),
        ...(data?.surcharges ?? []),
      ].reduce((acc, field) => {
        acc[field.name] = field.displayName;
        return acc;
      }, {} as Localisation);

      return {
        ...fieldLocalisation,
        ...portalCostTypeMap,
      };
    },
    [isLoading, data],
  );

  return {
    isLoading,
    localisation,
  };
};
